import { PostDataType } from "data/types";
import React from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Comment from "shared/Comment/Comment";
import NcImage from "shared/NcImage/NcImage";
// import SocialsList from "shared/SocialsList/SocialsList";
import Textarea from "shared/Textarea/Textarea";
import { Helmet } from "react-helmet";
import ReactMarkdown from "react-markdown";
import { useFetch } from "hooks/useFetch";
import { IBlog } from "types/blog";
import { dateToString } from "utils/timeConvert";
import { loadingClass } from "utils/loadingClass";
import { RentripsURL } from "utils/request";

const BlogSingle = () => {
	const path = window.location.pathname;
	const { data, loading } = useFetch<Partial<IBlog>>(RentripsURL +`/api${path}`, {
		title: "",
		published: new Date().toLocaleString(),
	});
	const renderHeader = () => {
		return (
			<header className="container rounded-xl">
				<div className="max-w-screen-md mx-auto space-y-5">
					<Badge href="##" name={data?.category || "Travel"} />
					<h1
						className={` text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl ${
							loading && loadingClass({ height: "h-10", width: "w-full" })
						}`}
						title="Quiet ingenuity: 120,000 lunches and counting"
					>
						{data?.title || ""}
					</h1>
					<span
						className={`block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1 ${
							loading && loadingClass({ height: "h-5", width: "w-full" })
						}`}
					>
						{data?.subtitle || ""}
					</span>

					<div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
					<div className="flex flex-col items-baseline sm:flex-row sm:justify-between">
						<div className="nc-PostMeta2 flex items-center flex-wrap text-neutral-700 text-left dark:text-neutral-200 text-sm leading-none flex-shrink-0">
							<Avatar
								containerClassName="flex-shrink-0"
								sizeClass="w-8 h-8 sm:h-11 sm:w-11 "
							/>
							<div className="ml-3">
								<div
									className={`flex items-center ${loading && loadingClass()}`}
								>
									<a
										className="block font-semibold"
										href={`/user/${data?.authorId}`}
									>
										{data?.author?.displayName || ""}
									</a>
								</div>
								<div className="text-xs mt-[6px]">
									<span className={`text-neutral-700 dark:text-neutral-300`}>
										{dateToString(data?.published || "")}
									</span>
								</div>
							</div>
						</div>
						{/* <div className="mt-3 sm:mt-0 sm:ml-3">
              <SocialsList />
            </div> */}
					</div>
				</div>
			</header>
		);
	};
	// eslint-disable-next-line
	const renderTags = () => {
		return (
			<div className="max-w-screen-md mx-auto flex flex-wrap">
				<a
					className="nc-Tag inline-block bg-white text-sm text-neutral-600 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
					href="##"
				>
					Garden
				</a>
				<a
					className="nc-Tag inline-block bg-white text-sm text-neutral-600 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
					href="##"
				>
					Jewelry
				</a>
				<a
					className="nc-Tag inline-block bg-white text-sm text-neutral-600 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
					href="##"
				>
					Tools
				</a>
			</div>
		);
	};
	// eslint-disable-next-line
	const renderAuthor = () => {
		return (
			<div className="max-w-screen-md mx-auto ">
				<div className="nc-SingleAuthor flex">
					<Avatar sizeClass="w-11 h-11 md:w-24 md:h-24" />
					<div className="flex flex-col ml-3 max-w-lg sm:ml-5 space-y-1">
						<span className="text-xs text-neutral-400 uppercase tracking-wider">
							WRITEN BY
						</span>
						<h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
							<Link to="/ncmaz/author/the-demo-author-slug">Fones Mimi</Link>
						</h2>
						<span className="text-sm text-neutral-500 sm:text-base dark:text-neutral-300">
							There’s no stopping the tech giant. Apple now opens its 100th
							store in China.There’s no stopping the tech giant.
							<a
								className="text-primary-6000 font-medium ml-1"
								href="/ncmaz/author/the-demo-author-slug"
							>
								Readmore
							</a>
						</span>
					</div>
				</div>
			</div>
		);
	};
	// eslint-disable-next-line
	const renderCommentForm = () => {
		return (
			<div className="max-w-screen-md mx-auto pt-5">
				<h3 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
					Responses (14)
				</h3>
				<form className="nc-SingleCommentForm mt-5">
					<Textarea />
					<div className="mt-2 space-x-3">
						<ButtonPrimary>Submit</ButtonPrimary>
						<ButtonSecondary>Cancel</ButtonSecondary>
					</div>
				</form>
			</div>
		);
	};
	// eslint-disable-next-line
	const renderCommentLists = () => {
		return (
			<div className="max-w-screen-md mx-auto">
				<ul className="nc-SingleCommentLists space-y-5">
					<li>
						<Comment />
						<ul className="pl-4 mt-5 space-y-5 md:pl-11">
							<li>
								<Comment isSmall />
							</li>
						</ul>
					</li>
					<li>
						<Comment />
						<ul className="pl-4 mt-5 space-y-5 md:pl-11">
							<li>
								<Comment isSmall />
							</li>
						</ul>
					</li>
				</ul>
			</div>
		);
	};
	// eslint-disable-next-line
	const renderPostRelated = (post: PostDataType) => {
		return (
			<div
				key={post.id}
				className="relative aspect-w-3 aspect-h-4 rounded-3xl overflow-hidden group"
			>
				<Link to={post.href} />
				<NcImage
					className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-300"
					src={post.featuredImage}
				/>
				<div>
					<div className="absolute bottom-0 inset-x-0 h-1/2 bg-gradient-to-t from-black"></div>
				</div>
				<div className="flex flex-col justify-end items-start text-xs text-neutral-300 space-y-2.5 p-4">
					<Badge name="Categories" />
					<h2 className="block text-lg font-semibold text-white ">
						<span className="line-clamp-2">{post?.title}</span>
					</h2>

					<div className="flex">
						<span className="block text-neutral-200 hover:text-white font-medium truncate">
							{post.author.displayName}
						</span>
						<span className="mx-1.5 font-medium">·</span>
						<span className="font-normal truncate">{post.date}</span>
					</div>
				</div>
				<Link to={post.href} />
			</div>
		);
	};

	return (
		<div className="nc-PageSingle pt-8 lg:pt-16 ">
			<Helmet>
				<title>{data?.title || "Blog"} | Rentrips.id </title>
				<meta
					name="description"
					content={
						data?.subtitle ||
						"Baca blog seputar perjalanan, travel, dan penyewaan hanya di Rentrips.id"
					}
				/>
			</Helmet>
			{renderHeader()}
			<NcImage
				className={`w-full object-contain h-full object-center ${
					loading && loadingClass({ height: "h-96", width: "w-full" })
				}`}
				containerClassName="container my-10 sm:my-12 max-h-96  overflow-hidden"
				src={data.image || "."}
			/>

			<div className="nc-SingleContent container space-y-10 pb-32">
				{loading &&
					[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
						<div
							key={i}
							className={`mx-auto ${loadingClass({ width: "w-3/4" })}`}
						></div>
					))}
				<ReactMarkdown
					children={data.content || ""}
					className="prose prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
				></ReactMarkdown>
				{/* {renderTags()} */}
				<div className="max-w-screen-md mx-auto border-b border-t border-neutral-100 dark:border-neutral-700"></div>
				{/* {renderAuthor()} */}
				{/* {renderCommentForm()}
        {renderCommentLists()} */}
			</div>
			{/** OTHER ARTICLE */}
			{/* <div className="relative bg-neutral-100 dark:bg-neutral-800 py-16 lg:py-28 mt-16 lg:mt-24">
        <div className="container ">
          <h2 className="text-3xl font-semibold">Artikel-artikel lainnya</h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {DEMO_POSTS.filter((_, i) => i < 4).map(renderPostRelated)}
          </div>
        </div>
      </div> */}
		</div>
	);
};

export default BlogSingle;
